import axios from 'axios';
import authHeader from './auth-header';

const API_URL = 'https://dacmethodbackend.herokuapp.com/api/test/';

class UserService {
  getPublicContent() {
    return axios.get(API_URL + 'all');
  }

  getUserBoard() {
    console.log({ headers: authHeader() })
    return axios.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard() {
    return axios.get(API_URL + 'mod', { headers: authHeader() });
  }

  getAdminBoard() {
    return axios.get(API_URL + 'admin', { headers: authHeader() });
  }
  //test per recuperare tutti gli utenti!
  getAllUsers() {
    return axios.get(API_URL + 'users', { headers: authHeader() });
  }
  getNumberUsers(){
    return axios.get(API_URL + 'numberusers', {headers:authHeader() });
  }
}

export default new UserService();
